import { Button } from "@/components/ui/button";
import { DataTableColumnHeader } from "../../components/ui/database-column-header";
import { useNavigate } from "react-router-dom";
import { HiTrash } from "react-icons/hi2";
import { useRemoveContractLeads } from "./useRemoveContractLeads";
import  { formatDate2, toPascalCase } from "../../utils/helpers";

function DeleteAction({ contract }) {
  const { mutate: removeLead } = useRemoveContractLeads();
  const proposalId = String(contract.id);
  const searchType = contract.searchType;

  return (
    <Button
      variant="ghost"
      className="h-8 w-8 p-0"
      onClick={() => removeLead({ proposalId, searchType })}
    >
      <HiTrash className="text-gray-600" />
      <span className="sr-only">Delete</span>
    </Button>
  );
}

function RowComponent({ row, children }) {
  const navigate = useNavigate();
  const contract = row.original;

  return (
    <div
      className="cursor-pointer"
      onClick={() => navigate(`/contract/grant/${contract.id}`)}
    >
      {children}
    </div>
  );
}

export const grantColumns = [
  {
    accessorKey: "opportunityTitle",
    header: ({ column }) => (
      <DataTableColumnHeader
        column={column}
        title="Title"
        className="w-[400px]"
      />
    ),
    cell: ({ row }) => (
      <RowComponent row={row}>
        <div className="font-medium">
          {toPascalCase(row.getValue("opportunityTitle"))}
        </div>
      </RowComponent>
    ),
  },
  {
    accessorFn: (row) =>
      row.synopsis?.responseDate || row.forecast?.responseDate,
    id: "responseDate", // Required when using accessorFn
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Deadline" />
    ),
    cell: ({ row }) => {
      return (
        <RowComponent row={row}>
          {formatDate2(row.getValue("responseDate"))}
        </RowComponent>
      );
    },
  },
  {
    accessorKey: "oppStatus",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Status" />
    ),
    cell: ({ row }) => (
      <RowComponent row={row}>
        <div>{toPascalCase(row.getValue("oppStatus"))}</div>
      </RowComponent>
    ),
  },
  {
    accessorKey: "opportunityCategory",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Category" />
    ),
    cell: ({ row }) => (
      <RowComponent row={row}>
        <div>{row.getValue("opportunityCategory")}</div>
      </RowComponent>
    ),
  },
  {
    id: "delete",
    header: "Delete",
    cell: ({ row }) => <DeleteAction contract={row.original} />,
    className: "sticky-col w-[100px]",
  },
];
